import "../../../assets/css/admin/contents/ContentForm.css";
import NoticeForm from "./NoticeForm";
import EventForm from "./EventForm";
import PartnerForm from "./PartnerForm";

function ContentForm({
  mode = "write",
  category = "notice",
  initialData = {},
  onCancel,
  onSaveComplete,
}) {
  if (category === "notice") {
    return (
      <NoticeForm
        mode={mode}
        initialData={initialData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}
      />
    );
  }

  if (category === "event") {
    return (
      <EventForm
        mode={mode}
        initialData={initialData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}
      />
    );
  }

  if (category === "partner") {
    return (
      <PartnerForm
        mode={mode}
        initialData={initialData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}
      />
    );
  }

  return (
    <div className="content-form-page">
      <h2 className="content-form-title">지원하지 않는 게시글 유형입니다.</h2>
    </div>
  );
}

export default ContentForm;